// extracted by mini-css-extract-plugin
module.exports = {"steps":"Steps_steps__TEXR2","step":"Steps_step__3LNBk","stepIcon":"Steps_stepIcon__xXdUm"};